<div class="field row" *ngIf="value">
  <label class="field-label" for="contract-end" translate="contractEndLabel"></label>
  <span class="field-data qa-contract-end-date-value" id="contract-end" 
    [ngClass]="{'contract-end': alertExists}" 
    [textContent]="value | localeDate"></span>
</div>
